export function stripHtml(html: string): string {
	if (!html) { return '' }

	try {
		const parser = new DOMParser()
		const parsed = parser.parseFromString(html, 'text/html')
		return parsed.body?.textContent || parsed.documentElement?.textContent || ''
	} catch {
		return html.replace(/<[^>]*>/g, '')
	}
}
